import { IPD_GET_ADMISSION_ADVICE } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    data?: DataEntity[];
}
export interface DataEntity {
    id: string;
    advised: boolean;
    created_at: string;
    docid: string;
    include_procedures: boolean;
    notes: string;
    patientid: string;
    procedures?: ProceduresEntity[] | null;
    pxid: string;
    visitid: string;
}
export interface ProceduresEntity {
    id: string;
    name: string;
    date: string;
    notes: string;
}

export default (pid: string): Promise<Response> => {
    return fetchWithRefresh(IPD_GET_ADMISSION_ADVICE(pid), {
        method: 'GET',
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
